export const IS_SERVER = typeof document === "undefined";

export const ALL_EMPLOYEES_PARAM = "__all_employees__";

export function parseEmployeeId(employeeId?: string | null) {
  if (!employeeId || employeeId === ALL_EMPLOYEES_PARAM) {
    return null;
  }

  return employeeId;
}
